<template>
  <div style="width:100%;height:100%">
    <div
      style="width: 100%; height: 100%"
      ref="myCharts"
      class="pie_item"
      id="icon2"
    ></div>
  </div>
</template>

<script>
export default {
  name: "Process",
  data() {
    return {
      data1: [],
      data2: [],
    };
  },
  mounted() {
    this.getData()

    setInterval(() => {
      this.getData()
    }, 900000);

  },
  methods: {
    getData(){
   this.$axios
      .get(
              `${this.$url}/admin/bigpin5`

      )
      .then((res) => {
        let datas = JSON.parse(res.data.split('<\/script>')[1]).data
        this.data1 = datas.rows.map((item) => item[0]); //工艺
        this.data2 = datas.rows.map((item) => item[1]); //数值
        this.echarts(this.data1, this.data2);
      });

    },
    echarts(data1, data2) {
      let myEcharts = this.$echarts.init(document.getElementById("icon2"));

      let option = {
        color: ["#3398DB"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "0",
          right: "0",
          bottom: "0",
          top:"10",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: data1,
            axisTick: {
              alignWithLabel: true,
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              lineStyle: {
                color: "#fff",
              },
            },
          },
        ],
        series: [
          {
            name: "生产量",
            type: "bar",
            barWidth: "60%",
            data: data2,
          },
        ],
      };

      myEcharts.setOption(option);
    },
  },
};
</script>

<style>
</style>